import { render, staticRenderFns } from "./MsinAdd.vue?vue&type=template&id=74e307c8&scoped=true&"
import script from "./MsinAdd.vue?vue&type=script&lang=js&"
export * from "./MsinAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e307c8",
  null
  
)

export default component.exports